import createIcon from '../../createIcon';

/**
 * @component @name ShoppingBag
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggNkgxNkMxNiAzLjc5IDE0LjIxIDIgMTIgMkM5Ljc5IDIgOCAzLjc5IDggNkg2QzQuOSA2IDQgNi45IDQgOFYyMEM0IDIxLjEgNC45IDIyIDYgMjJIMThDMTkuMSAyMiAyMCAyMS4xIDIwIDIwVjhDMjAgNi45IDE5LjEgNiAxOCA2Wk0xMCAxMEMxMCAxMC41NSA5LjU1IDExIDkgMTFDOC40NSAxMSA4IDEwLjU1IDggMTBWOEgxMFYxMFpNMTIgNEMxMy4xIDQgMTQgNC45IDE0IDZIMTBDMTAgNC45IDEwLjkgNCAxMiA0Wk0xNiAxMEMxNiAxMC41NSAxNS41NSAxMSAxNSAxMUMxNC40NSAxMSAxNCAxMC41NSAxNCAxMFY4SDE2VjEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ShoppingBag = createIcon('ShoppingBag', [
  [
    'path',
    {
      d: 'M18 6H16C16 3.79 14.21 2 12 2C9.79 2 8 3.79 8 6H6C4.9 6 4 6.9 4 8V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8C20 6.9 19.1 6 18 6ZM10 10C10 10.55 9.55 11 9 11C8.45 11 8 10.55 8 10V8H10V10ZM12 4C13.1 4 14 4.9 14 6H10C10 4.9 10.9 4 12 4ZM16 10C16 10.55 15.55 11 15 11C14.45 11 14 10.55 14 10V8H16V10Z',
      key: 'sxxte3',
    },
  ],
]);

export default ShoppingBag;
